import type { QueryResult } from './query-result';

export const mapQueryResultRows = <TRow>(result: QueryResult): TRow[] => {
  return result.values.map(
    (row: unknown[]) =>
      row.reduce<Record<string, unknown>>((mappedRow: Record<string, unknown>, value: unknown, idx: number) => {
        mappedRow[result.columns[idx]] = value;
        return mappedRow;
      }, {}) as TRow,
  );
};
